enum PaymentMode {
  PerInstruction = 'PerInstruction',
  Stripe = 'Stripe'
}

export default PaymentMode;
